var _rect, _path, _ellipse, _ellipse2, _ellipse3, _path2, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 85,
    viewBox: "0 0 148 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.8811,
    y: 1.68579,
    width: 144.238,
    height: 81.6172,
    rx: 9,
    fill: "white",
    stroke: "#BCC4D6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.881104 16.1569L147.119 16.1568",
    stroke: "#CCD2E0",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6944,
    cy: 9.34225,
    rx: 2.02597,
    ry: 2.02597,
    fill: "#BCC4D6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.43246,
    cy: 9.34225,
    rx: 2.02597,
    ry: 2.02597,
    fill: "#BCC4D6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.9566,
    cy: 9.34225,
    rx: 2.02597,
    ry: 2.02597,
    fill: "#BCC4D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.063 59.633C80.4007 59.633 84.5203 55.3534 86.5412 51.1465C87.3695 49.4222 85.9586 47.643 84.0457 47.643L64.2405 47.643C62.2769 47.643 60.8527 49.5085 61.7294 51.2655C63.8093 55.4336 67.7849 59.633 74.063 59.633Z",
    fill: "#5D6A86"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.826,
    cy: 37.2453,
    rx: 3.46588,
    ry: 3.46588,
    fill: "#8894AC"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.6214,
    cy: 37.2453,
    rx: 3.46588,
    ry: 3.46588,
    fill: "#8894AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpHero);
export default __webpack_public_path__ + "static/media/help-hero.8824b9d815ff9fac4711b3f27e086a50.svg";
export { ForwardRef as ReactComponent };